import { ApiError } from "@vana/core";

export class ListRouteError extends ApiError {}

export class GetDeliveryDetailError extends ApiError {}

export class StartRouteError extends ApiError {}

export class ConfirmDeliveryError extends ApiError {}
